var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar',{attrs:{"title":"true"}}),_c('v-content',[_c('message'),_c('v-container')],1),_c('footer-button',{ref:"footerButton",attrs:{"redirection":"/refresh","name":"Intentar de nuevo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }